"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setError = exports.setTablePagination = exports.setSelectedReview = exports.setReviews = exports.setIsLoading = exports.initialReviewValues = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.initialReviewValues = {
    customer_name: "",
    rating: 0,
    review_text: "",
    date: "",
    image: "",
    status: "draft",
};
var initialPaginationValues = {
    page: 1,
    size: 10,
    countTotal: 0,
};
var initialState = {
    reviews: [],
    selectedReview: exports.initialReviewValues,
    isLoading: false,
    error: null,
    pagination: initialPaginationValues,
};
var slice = (0, toolkit_1.createSlice)({
    name: "reviews",
    initialState: initialState,
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setReviews: function (state, action) {
            state.reviews = action.payload;
        },
        setSelectedReview: function (state, action) {
            state.selectedReview = action.payload;
        },
        setTablePagination: function (state, action) {
            state.pagination = action.payload;
        },
        setError: function (state, action) {
            state.error = action.payload;
        },
    },
});
exports.setIsLoading = (_a = slice.actions, _a.setIsLoading), exports.setReviews = _a.setReviews, exports.setSelectedReview = _a.setSelectedReview, exports.setTablePagination = _a.setTablePagination, exports.setError = _a.setError;
exports.default = slice.reducer;
